import { RatingScale } from './types'

export const MAX_SCALES = 7


export const LEVEL_COLORS: Record<number, string> = {
  [-3]: '#B21A1A',
  [-2]: '#B2661A',
  [-1]: '#BDA00F',
  [0]: '#39C674',
  [1]: '#1F7A45',
  [2]: '#1A59B2',
  [3]: '#0D2D59',
}

export const STATIC_RATING_SCALES: Array<Omit<RatingScale, 'id'>> = [
  {
    kind: 'mapped',
    baseLabel: 'Working Towards',
    label: '',
    description: '',
    color: LEVEL_COLORS[-1],
    scaleValue: -1,
  },
  {
    kind: 'mapped',
    baseLabel: 'Meeting',
    label: '',
    description: '',
    color: LEVEL_COLORS[0],
    scaleValue: 0,
  },
  {
    kind: 'mapped',
    baseLabel: 'Exceeding',
    label: '',
    description: '',
    color: LEVEL_COLORS[1],
    scaleValue: 1,
  },
]
